import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'
import { TREATMENT_QUOTATION_CREATED } from './state-name'
import * as processAction from '../../process-action'


export default createUIDefinition({
    taskName: null,
    stateNameList: [
        TREATMENT_QUOTATION_CREATED,
    ],
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.IMPLANT_TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
    ],
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/treatment-quotation-created.js